import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './breadcrumbs.component';
import { BreadcrumbsItemDirective } from './breadcrumbs-item.directive';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BreadcrumbsComponent, BreadcrumbsItemDirective],
  imports: [CommonModule, MatIconModule],
  exports: [BreadcrumbsComponent, BreadcrumbsItemDirective],
})
export class BreadcrumbsModule {}
